export default {
    "name": "PartEcommerceStatus",
    "kind": "HoudiniQuery",
    "hash": "14587d6c542283ffd45bc1b1a23a0b0e91c0b90d3de5558b593b2c407a0d730c",

    "raw": `query PartEcommerceStatus($sku: Int!, $storeId: Int!) {
  inventoryBySkuAndStore(sku: $sku, storeId: $storeId) {
    ecommerceStatus: htpAvailability {
      details
      listed
      recommendation
    }
    id
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "inventoryBySkuAndStore": {
                "type": "Inventory",
                "keyRaw": "inventoryBySkuAndStore(sku: $sku, storeId: $storeId)",

                "selection": {
                    "fields": {
                        "ecommerceStatus": {
                            "type": "HtpAvailability",
                            "keyRaw": "ecommerceStatus",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "details": {
                                        "type": "String",
                                        "keyRaw": "details",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "listed": {
                                        "type": "Boolean",
                                        "keyRaw": "listed",
                                        "visible": true
                                    },

                                    "recommendation": {
                                        "type": "String",
                                        "keyRaw": "recommendation",
                                        "nullable": true,
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "sku": "Int",
            "storeId": "Int"
        },

        "types": {},
        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=ee14f57816ec09d8ffef05e3c65771a668f38c35ca5d2ea892902ddb8da3a7b2";